function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.438 5.344a1.312 1.312 0 102.624 0 1.312 1.312 0 00-2.625 0zm0 6.656a1.313 1.313 0 102.625 0 1.313 1.313 0 00-2.625 0zm0 6.656a1.312 1.312 0 102.624 0 1.312 1.312 0 00-2.625 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.688 4.5h13.687c.103 0 .188.084.188.188V6a.188.188 0 01-.188.188H7.687A.188.188 0 017.5 6V4.687c0-.103.084-.187.188-.187zm0 6.656h13.687a.19.19 0 01.188.188v1.312a.188.188 0 01-.188.188H7.687a.188.188 0 01-.187-.188v-1.312c0-.103.084-.188.188-.188zm0 6.657h13.687c.103 0 .188.084.188.187v1.313a.188.188 0 01-.188.187H7.687a.188.188 0 01-.187-.188V18c0-.103.084-.188.188-.188z",
  opacity: ".4"
})));